<script>
  import { ref, watch } from '@nuxtjs/composition-api'
  import { getNumberInBounds } from '@/utils/utils'

  export default {
    props: {
      id: {
        type: String,
        required: true
      },
      label: {
        type: String,
        default: 'Aantal'
      },
      max: {
        type: Number,
        default: undefined
      },
      min: {
        type: Number,
        default: 1
      },
      value: {
        type: Number,
        required: true
      }
    },
    setup (props, { emit }) {
      const getValidValue = n => getNumberInBounds(Number(n), props.min, props.max)

      const internalValue = ref(getValidValue(props.value))

      watch(internalValue, (value) => {
        emit('onChange', value)
      })

      const onButtonClick = (e, change) => {
        e.preventDefault()
        internalValue.value = getValidValue(internalValue.value + change)
      }

      const onInputBlur = ({ target: { value } }) => {
        internalValue.value = getValidValue(value)
      }

      return {
        internalValue,
        onButtonClick,
        onInputBlur
      }
    }
  }

</script>

<template>
  <div class="number-input flex items-center gap-x-3">
    <label
      :for="id"
      class="text-gray-600"
    >
      {{ label }}
    </label>
    <div class="flex flex-nowrap">
      <button
        class="h-10 w-10 flex justify-center items-center border border-r-0 border-gray-300 rounded-l-lg text-gray-700"
        type="button"
        :disabled="internalValue <= min"
        @click="(e) => onButtonClick(e, -1)"
      >
        <q-icon
          name="minus-small"
          fill
          class="text-sm"
        />
      </button>
      <input
        :id="id"
        class="h-10 py-3 border border-gray-300 text-gray-700 text-center"
        type="number"
        :min="min"
        :max="max"
        :value="internalValue"
        @blur="onInputBlur"
      >
      <button
        class="h-10 w-10 flex justify-center items-center border border-l-0 border-gray-300 rounded-r-lg text-gray-700"
        type="button"
        :disabled="max !== undefined && internalValue >= max"
        @click="(e) => onButtonClick(e, 1)"
      >
        <q-icon
          name="plus-small"
          fill
          class="text-sm"
        />
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.number-input {

  input {
    @apply h-10;
    @apply px-1;

    width: auto;
    min-width: 2.7rem;

    &:focus {
      @apply text-black;
    }

    /* remove default number input chrome */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    &[type=number] {
      -moz-appearance: textfield;
    }
  }

  button {

    &:hover {
      @apply text-black;
    }

    &:disabled {
      @apply border-gray-100;
      @apply text-gray-300;
    }
  }
}
</style>
